import { PreviewPlanRequest } from "@client/requests";
import {
  SubscriptionPlanPreviewResource,
  subscriptionPlanPreviewResourceSchema,
} from "@client/resources/SubscriptionPlanPreviewResource";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { object } from "yup";

export type PostCheckoutPlanPreviewResponse =
  ApiResponse<SubscriptionPlanPreviewResource>;

const postCheckoutPlanPreviewResponseSchema = object({
  data: subscriptionPlanPreviewResourceSchema.defined(),
});

export const postCheckoutPlanPreview = async (
  payload: PreviewPlanRequest,
): Promise<PostCheckoutPlanPreviewResponse> => {
  const response = await fetchData(
    "/dietitian/checkout/plan/preview",
    APIMethods.POST,
    payload,
  );

  return await postCheckoutPlanPreviewResponseSchema
    .validate(response)
    .catch(logFetchValidateError("/dietitian/checkout/plan/preview"));
};
